import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import '@/styles/global.less'
import defaultImg from '@/components/defaultImg/index'
import breadcrumb from '@/components/breadcrumb/index'
import cusTable from '@/components/cusTable/index'
import constantNum from '@/components/constantNum/index'

Vue.config.productionTip = false

import {showMessage} from '@/utils/tools'
Vue.prototype.$showMessage = showMessage // 全局方法，展示不同的消息提示

Vue.use(defaultImg)
Vue.use(breadcrumb)
Vue.use(cusTable)
Vue.use(constantNum)

import AMap from 'vue-amap'
Vue.use(AMap)
// 初始化地图
AMap.initAMapApiLoader({
  key: '66823d1fbf87ba185e07ff0fe056fc8c',
  plugin: ['AMap.Autocomplete','AMap.Geolocation', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']    // 插件集合
})

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vue
